import { runtimeConfig } from "@/runtime-config";
import { ViewerTool } from "@/store/features/features";
import {
  ExperimentalIcon,
  FaroDialog,
  FaroIconButton,
  FaroTooltip,
  NO_TRANSLATE_CLASS,
} from "@faro-lotv/flat-ui";
import { useState, type JSX } from "react";
import { FeaturesDialogTable } from "./features-dialog-table";

type FeaturesDialogButtonProps = {
  /** The tool to show the features for. */
  tool: ViewerTool;
};

/**
 *
 * @returns An icon button opening the features page
 */
export function FeaturesDialogButton({
  tool,
}: FeaturesDialogButtonProps): JSX.Element | null {
  const [isOpen, setIsMenuOpen] = useState(false);

  // Do not show the button in prod
  if (runtimeConfig.deployment.environment.includes("prod")) {
    return null;
  }

  return (
    <>
      <FaroTooltip title="Experimental features" className={NO_TRANSLATE_CLASS}>
        <FaroIconButton onClick={() => setIsMenuOpen(!isOpen)}>
          <ExperimentalIcon />
        </FaroIconButton>
      </FaroTooltip>

      <FaroDialog
        title="Experimental features"
        open={isOpen}
        onClose={() => setIsMenuOpen(false)}
        size="l"
        height="100%"
      >
        <FeaturesDialogTable tool={tool} />
      </FaroDialog>
    </>
  );
}
